import { render, staticRenderFns } from "./ChatResultadosEvaluacion.vue?vue&type=template&id=6df98fd0&scoped=true"
import script from "./ChatResultadosEvaluacion.vue?vue&type=script&lang=js"
export * from "./ChatResultadosEvaluacion.vue?vue&type=script&lang=js"
import style0 from "./ChatResultadosEvaluacion.vue?vue&type=style&index=0&id=6df98fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df98fd0",
  null
  
)

export default component.exports